import { CircularProgress } from "@mui/material";
import React from "react";

const Loader = () => {
  return (
    <div className="loader_screen">
      <CircularProgress size={50} color="inherit" />
    </div>
  );
};

export default Loader;
